<template>
  <div>
    <div class="ui-filterbar" v-show="showPinFilters">
      <div class="ui-filterbar__content">
        <div>
          <span>{{ $t("role.orders.manage.filters.active.title") }}</span>
          <span class="ml-3" v-for="filter in pinFilters" :key="filter.name"
            >{{ filter.label }}: {{ filter.value }}
            <a href="#" @click.prevent="onResetPinFilter(filter)"
              ><font-awesome-icon icon="times"
            /></a>
          </span>
        </div>
        <div>
          <a href="#" @click.prevent="onResetPinFilters"
            ><font-awesome-icon icon="times" />
            {{ $t("role.orders.manage.filters.active.resetFilters") }}</a
          >
        </div>
      </div>
    </div>

    <form @submit.prevent="onSearch">
      <CRow class="align-items-end">
        <CCol md="3">
          <CInput
            :label="$t('role.orders.manage.filters.search.label')"
            :class="{
              'form-group--highlighted': hasValue(filters.keyword),
            }"
            :value="filters.keyword"
            @update:value="onSearchKeywordChange"
            :placeholder="$t('role.orders.manage.filters.search.placeholder')"
          >
            <template #prepend-content>
              <font-awesome-icon icon="search" />
            </template>
          </CInput>
        </CCol>
        <CCol md="2">
          <UiSelect
            :label="$t('role.orders.manage.filters.state.label')"
            :class="{
              'form-group--highlighted': hasValue(filters.statusId),
            }"
            :value="filters.statusId"
            :options="statusOptions"
            @update:value="onStatusSelected"
            custom
          />
        </CCol>
        <CCol md="2">
          <CSelect
            :label="$t('role.orders.manage.filters.conservation.label')"
            :class="{
              'form-group--highlighted': hasValue(filters.productTypeId),
            }"
            :value="filters.productTypeId"
            :options="productTypeOptions"
            @update:value="onProductTypeSelected"
            custom
          />
        </CCol>
        <CCol md="2">
          <CSelect
            :label="$t('role.orders.manage.filters.productType.label')"
            :class="{
              'form-group--highlighted': hasValue(filters.productLineId),
            }"
            :value="filters.productLineId"
            :options="productLineOptions"
            @update:value="onProductLineSelected"
            custom
          />
        </CCol>
        <CCol col="auto">
          <CButton
            class="mb-3 mr-2"
            variant="outline"
            color="primary"
            type="submit"
          >
            {{ $t("role.orders.manage.filters.button.search") }}
          </CButton>
          <CButton
            class="mb-3"
            variant="outline"
            color="primary"
            @click.prevent="onReset"
          >
            {{ $t("role.orders.manage.filters.button.reset") }}
          </CButton>
        </CCol>
      </CRow>
    </form>
  </div>
</template>

<script>
import UiSelect from "../../../../../common/form/UiSelect";
import { mapState } from "vuex";
import EventBus from "../../../../../helpers/EventBus";
export default {
  name: "OrdersManageFilter",

  components: {
    UiSelect,
  },
  data() {
    return {
      initialized: false,
    };
  },

  computed: {
    ...mapState("orders", ["filters"]),

    statusOptions() {
      return [
        {
          value: "",
          label: this.$t("role.orders.manage.filters.state.placeholder"),
        },
        ...this.filters.options.status,
      ];
    },

    productLineOptions() {
      return [
        {
          value: "",
          label: this.$t("role.orders.manage.filters.conservation.placeholder"),
        },
        ...this.filters.options.productLine,
      ];
    },

    productTypeOptions() {
      return [
        {
          value: "",
          label: this.$t("role.orders.manage.filters.productType.placeholder"),
        },
        ...this.filters.options.productType,
      ];
    },

    warehouseOptions() {
      return [
        {
          value: "",
          label: this.$t("role.orders.manage.filters.state.placeholder"),
        },
        ...this.filters.options.warehouse,
      ];
    },

    showPinFilters() {
      return this.$store.getters["orders/havePinFilters"];
    },

    pinFilters() {
      const filters = [];
      const labels = {
        producerId: "Produttore",
        productId: "Prodotto",
        orderId: "Ordine",
        islandId: "Isola",
      };
      const pinFilters = this.$store.getters["orders/pinFilters"];

      for (const filter in pinFilters) {
        const value = pinFilters[filter];
        if (value !== null && value.id) {
          filters.push({
            name: filter,
            label: labels[filter],
            value: value.label || value.id,
          });
        }
      }
      return filters;
    },
  },

  watch: {
    round() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      const self = this;
      const lang = this.$i18n.locale;
      const i18n = this.$i18n;
      const roleId = this.$store.state.role.id;

      self.initialized = false;
      this.$store
        .dispatch("orders/initFilters", {
          roleId,
          lang,
          i18n,
        })
        .then(() => {
          self.initialized = true;
        });
    },

    changeViewType(value) {
      this.$emit("update:viewType", value);
    },

    onSearchKeywordChange(value) {
      this.$store.commit("orders/updateKeyword", value);
    },

    onStatusSelected(value) {
      this.$store.commit("orders/updateStatusId", value);
    },

    onProductTypeSelected(value) {
      this.$store.commit("orders/updateProductTypeId", value);
    },

    onProductLineSelected(value) {
      this.$store.commit("orders/updateProductLineId", value);
    },

    onSearch() {
      EventBus.$emit("orders:applyFilters");
    },

    onResetPinFilters() {
      this.$store.commit("orders/resetPinFilters");
      this.onSearch();
    },

    onResetPinFilter(filter) {
      this.$store.commit("orders/resetPinFilter", [filter.name]);
      this.onSearch();
    },

    hasValue(value) {
      return value !== "";
    },

    onReset() {
      this.$store.commit("orders/resetMainFilters");
      this.onSearch();
    },
  },
};
</script>
